<ngx-bootstrap-multiselect
  [options]="countries"
  [settings]="dropdownSettings"
  [(ngModel)]="selectedCountry">
</ngx-bootstrap-multiselect>
